import React, { createElement, useEffect } from "react";
import { MButton } from "@app/components";
import { useNavigate, useParams } from "react-router-dom";
import { useMasterTables } from "./utils/useMasterTables";
import { errorAlert } from "@app/utils/alerts";
import pathRoutes from "../../routes/pathRoutes";
import { FormProvider, useForm } from "react-hook-form";
import { CreatePageList } from "@app/components/Layouts/PageList";
import { Box } from "@mui/material";
import MasterTablesForm from "./components/masterTablesForm";
import { configTable } from "./utils/helpers";

const getDefaultValues = (data: Record<string, any>, atributtes: string[]) => {
  const defaultValues: Record<string, any> = {};
  atributtes.forEach((atributte) => {
    defaultValues[atributte] = data[atributte] || undefined;
  });
  return defaultValues;
};

const EditMasterTables: React.FC = () => {
  const { nameTable, idTable } = useParams<{
    nameTable: string;
    idTable: string;
  }>();
  const navigate = useNavigate();
  const { get, atributtes, save } = useMasterTables();

  const form = useForm({
    mode: "all",
    defaultValues: {},
  });

  const handleBack = () => {
    navigate(`${pathRoutes.ADMIN_MASTER_TABLES}`);
  };

  useEffect(() => {
    if (idTable) {
      const currentTable = get(Number(idTable));
      if (!currentTable) {
        errorAlert("Tabla no encontrada");
        handleBack();
        return;
      }
      const defaultValues =
        nameTable && configTable[nameTable]
          ? configTable[nameTable].getDefaultValues(currentTable)
          : getDefaultValues(currentTable, atributtes);

      form.reset(defaultValues);
    }
  }, [idTable]);

  const submit = async (data: any) => {
    if (nameTable) {
      const status = await save(
        configTable[nameTable] ? configTable[nameTable].mapData(data) : data,
        nameTable
      );
      if (!status) {
        handleBack();
      }
    }
  };

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(submit)}>
        <CreatePageList
          title={
            idTable
              ? `Editar Registro ${nameTable}`
              : `Nuevo Registro ${nameTable}`
          }
          footer={
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
              }}
            >
              <MButton
                variant="contained"
                color="primary"
                text="Guardar"
                type="submit"
              />
              <MButton
                variant="outlined"
                color="secondary"
                sx={{ ml: 2 }}
                text="Cancelar"
                onClick={handleBack}
              />
            </Box>
          }
        >
          {nameTable && configTable[nameTable] ? (
            createElement(configTable[nameTable].form, {})
          ) : (
            <MasterTablesForm atributtes={atributtes} />
          )}
        </CreatePageList>
      </form>
    </FormProvider>
  );
};

export default EditMasterTables;
